export abstract class ErrorWithStatus extends Error {
  public status: number | undefined = 500;
}

// FIXME: Match API of JS Error constructor (message first)
export class ApiError extends ErrorWithStatus {
  constructor(
    public type: string,
    public status: number,
    public errorId: string,
    public errorCode: string,
    public customerMessage: string,
    public message: string,
  ) {
    super(`${type}: ${status} ${message}`);
    Object.setPrototypeOf(this, ApiError.prototype);
  }
}

export class UrlError extends ErrorWithStatus {
  public status: number | undefined;
  constructor(public message: string, opts: { status?: number } = {}) {
    super(message);
    this.status = opts.status;
    Object.setPrototypeOf(this, UrlError.prototype);
  }
}

// FIXME: this should only need to check instanceOf
export const isApiError = (error: Error | ApiError): error is ApiError =>
  (error as ApiError).status !== undefined;
